import { TextField, InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useState } from "react";
import PropTypes from "prop-types";

const PasswordInput = ({ label, name, value, onChange, error, onBlur, isAutoFocus }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  return (
    <>
      <TextField
        label={label}
        name={name}
        type={showPassword ? "text" : "password"}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        className={`password-input-ms ${error ? "error" : ""}`}
        fullWidth
        variant="outlined"
        autoFocus={isAutoFocus}
        sx={{
          "& label": {
            color: error ? "#d50000" : "#3c3c3c",
          },
          "& label.Mui-focused": {
            color: error ? "#d50000" : "#3c3c3c",
          },
          "& label.MuiInputLabel-shrink": {
            transform: "translate(14px, 8px) scale(0.75)",
          },
          "& .MuiOutlinedInput-root": {
            alignItems: "flex-start",
            paddingTop: "16px",
          },
          "& fieldset legend": {
            display: "none",
          },
          "& fieldset": {
            border: "none",
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="end"
              sx={{
                marginTop: "26px",
                marginRight: "18px",
              }}
            >
              <IconButton onClick={togglePasswordVisibility} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {typeof error === "string" && error && (
        <p className="validation-error">
          <span className="error-exclamation">!</span>
          {error}
        </p>
      )}
    </>
  );
};

export default PasswordInput;

PasswordInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  error: PropTypes.string,
  isAutoFocus: PropTypes.bool,
};
